<glxy-page [pagePadding]="false">
  <glxy-page-toolbar>
    <glxy-page-nav *ngIf="!this.hideBackNavigation && (previousPage$ | async) as previousPage">
      <glxy-page-nav-button
        [useHistory]="true"
        [historyBackButtonTitle]="'COMMON.ACTION_LABELS.BACK' | translate"
        [previousPageUrl]="previousPage.url"
        [previousPageTitle]="previousPage.text"
      ></glxy-page-nav-button>
    </glxy-page-nav>
    <glxy-page-title>
      <strong>{{ currentPageTitle$ | async }}</strong>
    </glxy-page-title>
    <div class="nav-content-and-action-items">
      @if (actions()) {
        <glxy-page-actions>
          @for (action of actions(); track action) {
            @if (action.link && action.navigationOption === 'routerLink') {
              <a [routerLink]="action.link" data-action="clicked-manage-booking-links">
                <ng-container *ngTemplateOutlet="actionButtonTemplate; context: { action: action }"></ng-container>
              </a>
            }
            @if (action.link && (!action.navigationOption || action.navigationOption === 'href')) {
              <a [href]="action.link" data-action="clicked-manage-booking-links">
                <ng-container *ngTemplateOutlet="actionButtonTemplate; context: { action: action }"></ng-container>
              </a>
            }
            @if (!action.link) {
              <ng-container
                *ngTemplateOutlet="actionButtonTemplate; context: { action: action }"
                data-action="clicked-manage-booking-links"
              ></ng-container>
            }
          }
        </glxy-page-actions>
      }
      <div class="margin-left" *ngIf="displayMyMeetingsActions">
        <meeting-scheduler-my-meetings-actions></meeting-scheduler-my-meetings-actions>
      </div>
    </div>
  </glxy-page-toolbar>
  <router-outlet></router-outlet>
</glxy-page>

<ng-template #actionButtonTemplate let-action="action">
  @switch (action.buttonType) {
    @case ('mat-icon-button') {
      <button mat-stroked-button>
        <mat-icon class="settings-icon">{{ action.icon }}</mat-icon>
        <strong> {{ action.labelTranslationKey | translate }}</strong>
      </button>
    }
    @case ('mat-raised-button') {
      <button mat-raised-button color="primary">
        @if (action.icon) {
          <mat-icon>{{ action.icon }}</mat-icon>
        }
        {{ action.labelTranslationKey | translate }}
      </button>
    }
    @case ('mat-button') {
      <button mat-button color="primary">
        @if (action.icon) {
          <mat-icon>{{ action.icon }}</mat-icon>
        }
        {{ action.labelTranslationKey | translate }}
      </button>
    }
    @case ('mat-stroked-button') {
      <button mat-stroked-button>
        @if (action.icon) {
          <mat-icon>{{ action.icon }}</mat-icon>
        }
        {{ action.labelTranslationKey | translate }}
      </button>
    }
  }
</ng-template>
